import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ElementStatus.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import GoCast from '../../Images/GoCast.png'
import { useParams, useLocation, useNavigate } from 'react-router-dom';

function ElementStatus_Details() {
    // Loading GIF
    const [isLoading, setIsLoading] = useState(false);
    // Search-bar
    const [searchOpen, setSearchOpen] = useState(false);
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);

    // Takes Parametres from URL and save it to Variables
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const UOM = queryParams.get('UOM');
    // Returns Dynamic Parameter from TruckForm :truckId
    const { projID } = useParams();

    // API CODE

    const [apiData1, setApiData1] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

    ////////////Go Back Navigate////////////////
    const navigate = useNavigate();
    const GoBack = () => {
        navigate(-1); // Navigates back to the previous page
    };
    ////////////////////////////////////////////




    const fetchData1 = async () => {
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl2 = `https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_ElementStatusDetail_Copy(PRECAST)?$filter= Calculated_PartLot_Project eq '${projID}' and Calculated_PrimaryUOM eq '${UOM}'`;
        try {
            const response = await fetch(apiUrl2, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                // console.log('API Data:', data.value);
                setApiData1(data.value);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    }
    useEffect(() => {
        fetchData1();
    }, []); // Add selectedProjectID as a dependency

    const renderTableRows1 = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData1.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>{item.Calculated_PartLot_Project}</td>
                <td>{item.PartLot_WBS_c}</td>
                <td>{item.PartLot_BuildingType_c}</td>
                <td>{item.PartLot_BuildingNumber_c}</td>
                <td>{item.PartLot_Floor_c}</td>
                <td>{item.PartLot_PartNum}</td>
                <td>{item.ProdGrup_Description}</td>
                <td>{item.PartLot_LotNum}</td>
                <td>{item.Calculated_Entered}</td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_Approved ? 'true' : ''}
                    />
                </td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_Casted ? 'true' : ''}
                    />
                </td>
                <td>{item.Calculated_InTransit}</td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_OnSite ? 'true' : ''}
                    />
                </td>
                <td>
                    <input
                        type="checkbox"
                        checked={item.Calculated_Erected ? 'true' : ''}
                    />
                </td>
                <td>{item.Calculated_PrimaryUOM}</td>
                <td>{item.PartLot_EstimatedCastingDate_c}</td>
                <td>{item.PartLot_ActualCastedDate_c}</td>
                <td>{item.Calculated_Current}</td>
                <td>{item.PartLot_ErectionPlannedDate_c}</td>
                <td>{item.PartLot_ActualErectionDate_c}</td>
                <td>{item.PartLot_OffloadDate_c}</td>
                <td>{item.Calculated_ErectionStatus}</td>
            </tr>
        ));
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData1.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Search Toggle
    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }

    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }

    return (
        <div className='TruckMastertable'>
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}


            <div className='card rebartable'>
                <div className="card-header">
                    <button type="button" className="toggle-table-icon" onClick={GoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <h2 className='panel-title'>Details</h2>
                </div>
                {/* Conditionally render the table */}
                {tableVisible && (
                    <div className="card-body">
                        <div class="table-responsive">
                            <div className="scrollable-table-body">
                                <table className="table table-bordered">
                                    {/* Table content */}
                                    <thead className='table-primary'>
                                        <tr className='bg-primary text-white text-nowrap'>
                                            <th>Project</th>
                                            <th>WBS</th>
                                            <th>ID1</th>
                                            <th>ID2</th>
                                            <th>ID3</th>
                                            <th>Part</th>
                                            <th>Product Group</th>
                                            <th>Element Number</th>
                                            <th>Entered</th>
                                            <th>Approved</th>
                                            <th>Casted</th>
                                            <th>In Transit</th>
                                            <th>OnSite</th>
                                            <th>Erected</th>
                                            <th>PrimaryUOM</th>
                                            <th>Estimated Casting Date</th>
                                            <th>Actual Casted Date</th>
                                            <th>Status</th>
                                            <th>Erection Planned Date</th>
                                            <th>Actual Erection Date</th>
                                            <th>Actual Delivery Date</th>
                                            <th>Erection Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderTableRows1()}
                                    </tbody>
                                </table>
                            </div>
                            <div className="pagination">
                                <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData1.length / itemsPerPage)}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ElementStatus_Details;
